import {
  ON_START_UPDATE_ARTIKEL_FORTNOX,ARTREG_ON_UPDATE_ARTIKEL_FORTNOX,ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX,
  ON_START_ADD_NEW_FREEINPUT_ARTIKEL,ON_ADD_NEW_FREEINPUT_ARTIKEL,ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL,
  ON_START_ARTIKEL_CLOSE_TOASTR,ON_GET_FREEINPUT_ARTIKEL,ON_START_GET_FREEINPUT_ARTIKEL,
  ON_START_GET_THIS_FREEINPUT_ARTIKEL,ON_GET_THIS_FREEINPUT_ARTIKEL,
  ON_START_DETELE_THIS_ARTICLE_FREEINPUT,ON_DETELE_THIS_ARTICLE_FREEINPUT,ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT,
  ON_START_UPDATE_FREEINPUT_ARTIKEL,ON_UPDATE_FREEINPUT_ARTIKEL,ON_ERROR_UPDATE_FREEINPUT_ARTIKEL,
  ON_START_GET_THIS_FREEINPUTS_ARTIKEL,ON_GET_THIS_FREEINPUTS_ARTIKEL,
  ON_START_GET_ARTEKLAR_EXCEL,ON_GET_ARTEKLAR_EXCEL,ON_ERROR_GET_ARTEKLAR_EXCEL,
  ON_START_IMPORT_ARTIKLAR_FUNC,ON_IMPORT_ARTIKLAR_FUNC,ON_ERROR_IMPORT_ARTIKLAR_FUNC,
  ON_START_Delete_SHARED_OFFICE,ON_Delete_SHARED_OFFIC,ON_ERROR_Delete_SHARED_OFFIC,
  ON_SET_ARTIKLAR_TAB_INDEX,
  ARTREG_ON_START_ADD_ARTIKEL,
  ARTREG_ON_ERROR_ADD_ARTIKEL,
  ARTREG_ON_ADD_ARTIKEL,

  ARTREG_ON_START_GET_ARTIKEL_NR,
  ARTREG_ON_ERROR_GET_ARTIKEL_NR,
  ARTREG_ON_GET_ARTIKEL_NR,

  ARTREG_ON_DELETE_ARTIKEL,
  ARTREG_ON_GET_ARTIKEL,
  ARTREG_ON_GET_ARTIKLAR,
  ARTREG_ON_START_GET_ARTIKLAR,
  ARTREG_ON_ERROR_GET_ARTIKLAR,
  ARTREG_ON_UPDATE_ARTIKEL,
  ARTREG_ON_START_UPDATE_ARTIKEL,
  ARTREG_ON_ERROR_UPDATE_ARTIKEL,
  ARTREG_ON_UPDATE_ARTIKEL_MULTI,
  ARTREG_ON_START_UPDATE_ARTIKEL_MULTI,
  ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI,
  ARTREG_ON_GET_ARTIKEL_COUNT,
  ARTREG_ON_CHANGE_ACTIVE_STATUS,

  ARTREG_START_GET_PRICELISTS,
  ARTREG_ERROR_GET_PRICELISTS,
  ARTREG_ON_GET_PRICELISTS,

  ARTREG_ON_DELETE_PRICELIST,
  ARTREG_ON_ADD_PRICELIST,
  ARTREG_ON_SET_PRIMARY_PRICELIST,


  ARTREG_ON_RESPOSE,
  ARTREG_ON_RESPOSE_RESET,
  ARTREG_ON_SEARCH_ARTIKLAR,
  ARTREG_ON_START_SEARCH_ARTIKLAR,
  ARTREG_ON_ERROR_SEARCH_ARTIKLAR,
  ARTREG_ON_GET_ARTIKEL_TAGS,
  ARTREG_ON_GET_ARTIKEL_SUB,
  ON_START_CREATE_WOOCOMMERCE_PRODUCT,
  ON_CREATE_WOOCOMMERCE_PRODUCT,
  ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT,
  ON_START_CONNECT_WOOCOMMERCE_PRODUCT,
  ON_CONNECT_WOOCOMMERCE_PRODUCT,
  ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT,
  ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT,
  ON_DISCONNECT_WOOCOMMERCE_PRODUCT,
  ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT,
  //Jack
  ON_START_NEW_ARTIKEL_TAGG,ON_NEW_ARTIKEL_TAGG,ON_ERROR_NEW_ARTIKEL_TAGG,ON_UPPDATE_ARTIKEL_TAGG,
  ON_DELETE_ARTIKEL_TAGG,
  FETCH_START_SET_UNAUTHE,
  ON_GET_ARTIKLAR_PAGE_BASIC,
  
  ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA,
  ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA,
  ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA,
}  from '../constants/ActionTypes'

import axios from 'util/Api' 
import {loadAktivaKalkylArtiklar,loadAktivaKalkylArtiklarJ} from 'actions'
import { isUndefined,isEmpty } from 'lodash'
import {RefreshUserInterface} from 'actions'
import fileSaver from 'file-saver' 
import {history} from '../store'
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'

const getClientIp = async () => {
  let Ipadress='0.0.0.0'
     return Ipadress
}

export const addArtikel = (art, _data, Userid, callback) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARTREG_ON_START_ADD_ARTIKEL})
    axios.post('artikelReg/add', {
      body: encrypt(JSON.stringify({
        Afid: art.Afid,
        Orgnr: art.Orgnr,
        Artnr: art.Artnr,
        Artname: art.Artname,
        Artimg: "imgLink",
        Type:  art.Type,
        Artlev:  art.Artlev,
        Utpris:  art.Utpris,
        Inpris:  art.Inpris,
        Vat:  art.Vat,
        Enhet:  art.Enhet,
        isShared:  art.isShared,
        FortnoxArticlenr:  art.FortnoxArticlenr,
        CreateInFortnox:  art.CreateInFortnox,
        Gprov:  art.Gprov,
        Visningsnamn:  art.Visningsnamn,
        Enummer:  art.enummer,
        Userid,
        ipAdress
      }))},{
      headers: {
        'Authorization':   `Bearer ${jwt}`
      }
    }).then( data => {
      console.log("addArtikel",data)
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        if(callback) callback(ndate.art)
        if(!isEmpty(_data)){
          dispatch(getArtiklarCount(_data.Afid, _data.Filter, Userid,_data.FilterState, _data.searchtext))
          dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj, _data.searchtext))
        }  
        dispatch({type: ARTREG_ON_ADD_ARTIKEL, payload: ndate.message})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikel2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_ERROR_ADD_ARTIKEL, payload: ndate.error})
      }
  }).catch(err => {
    dispatch({type: ARTREG_ON_ERROR_ADD_ARTIKEL, payload: err})
    console.log(err)
  })
  }
}

export const getArtiklelNr = (Afid, Userid) => {
  return async(dispatch) => {
    
    dispatch({type: ARTREG_ON_START_GET_ARTIKEL_NR})
    const jwt =  JSON.parse(localStorage.token);
     const ipAdress='0.0.0.0'
    axios.get('artikelReg/getArtiklelNr', { params:encrypt(JSON.stringify({Afid, Userid})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArtiklelNr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(RefreshUserInterface(Userid))
        dispatch({type: ARTREG_ON_GET_ARTIKEL_NR, payload: ndate.results.newArtNr})
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArtiklelNr2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_ERROR_GET_ARTIKEL_NR, payload: ndate.error})
      }
      
    }).catch(err => {
      dispatch({type: ARTREG_ON_ERROR_GET_ARTIKEL_NR, payload: err})
      console.log(err)
    })
  }
}
/*
export const deleteArtikel = (id, _data, Userid) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('artikelReg/delete', { params:{id,Userid,ipAdress},
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success){
        //dispatch(RefreshUserInterface(Userid))
        dispatch(getArtiklarCount(_data.Afid, _data.Filter, Userid))
        dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, Userid))
        dispatch({type: ARTREG_ON_DELETE_ARTIKEL, payload: data})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: 'Artikel #'+id+' borttagen!', show: true, type: 'warning'}})
      } else
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: 'Kunde inte ta bort #'+id+'!', show: true, type: 'error'}})
      console.log(data)
    }).catch(err => {
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: 'Kunde inte ta bort #'+id+'!', show: true, type: 'error'}})
      console.log(err)
    })
  }
}*/
//deleteArtikelJ
export const deleteArtikelJ = (Afid,userid,Artikel,page,Filter,pagesize,FilterState,SortObj,seachWord) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('artikelReg/deleteJ', { params:encrypt(JSON.stringify({
      Afid,userid,Artikel
    })),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("deleteArtikelJ",data)  
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteArtikelJ1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getArtiklarCount(Afid,Filter, userid,FilterState,seachWord))
        dispatch(getArtiklar(Afid, page, Filter, pagesize, userid,FilterState,SortObj,seachWord))
        dispatch({type: ARTREG_ON_DELETE_ARTIKEL, payload: ndate})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Avtion.Item.delete", `Artikel #${Artikel.id} borttagen!`,{item:Artikel.id}), show: true, type: 'warning'}})
     
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteArtikelJ2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Avtion.Item.delete.Error", `Kunde inte ta bort #${Artikel.id}!`,{item:Artikel.id}), show: true, type: 'error'}})
      }
    
    }).catch(err => {
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Avtion.Item.delete.Error", `Kunde inte ta bort #${Artikel.id}!`,{item:Artikel.id}), show: true, type: 'error'}})
      console.log(err)
    })
  }
}
//
export const getArtiklar = (afid, offset, aktiv, PageSize, Userid, FilterState, SortObj, SearchString="", Orgnr, WithSub = 0, FetchSubArtId = 0, prisLista=0, AktivOffert = 0) => {
  return async(dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    dispatch({type: ARTREG_ON_START_GET_ARTIKLAR})
    axios.get('artikelReg/get', { params:encrypt(JSON.stringify({
      Afid: afid, Offset: offset, Aktiv: aktiv, PageSize, Userid, FilterState, SortObj,
      ipAdress, Orgnr, WithSub, FetchSubArtId,prisLista,SearchString,AktivOffert
    })),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      dispatch(RefreshUserInterface(Userid))
      console.log("getArtiklar",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArtiklar1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_GET_ARTIKLAR, payload: {Artiklar:ndate.artiklar,PageSize,Page:(offset+1),Searchtext:SearchString}})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikel2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_ERROR_GET_ARTIKLAR})
      }    
    }).catch(err => {
      dispatch({type: ARTREG_ON_ERROR_GET_ARTIKLAR})
      console.log(err)
    })
  }
}
 export const fetchPricelistsByArtid = (userid,Afid, Artid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async(dispatch) => {
    return await axios.get('artikelReg/pricelists',
    { params:encrypt(JSON.stringify({
      Afid:Afid,Artid,userid:userid
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("fetchPricelistsByArtid",data)  
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("fetchPricelistsByArtid1: ", endata);
        let ndate = JSON.parse(endata)
        return ndate.results
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//
export const updatePrisFromList = (_data) => {
  return async (dispatch) => {
    console.log(_data,"KJJJJ")
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.put('artikelReg/updatePris', { body:{
     data: _data, Userid:_data.userid,ipAdress:ipAdress }},{ 
     headers: {
      'Authorization':   `Bearer ${jwt}`
      }
    }).then(({data}) => {
      //dispatch(RefreshUserInterface(_data.userid))
       
      console.log(_data,"_data") 
      dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, _data.userid,_data.filterState,_data.sortObj,_data.searchtext))
      dispatch(getArtiklarCount(_data.Afid, _data.Filter, _data.userid,[],_data.searchtext))
        dispatch({type: ARTREG_ON_CHANGE_ACTIVE_STATUS, payload: data})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true,msg: translate("Action.Save.Item"), show: true, type: 'success'}})
     
    }).catch(err => {
      console.log(err)
    })
  }
}
// updatePrisFromPrisList
export const updatePrisFromPrisList = (_data,Page,searchtext) => {
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true,msg: translate("Action.Saving.list"), show: true, type: 'info', loading: true}})
    axios.put('artikelReg/prislista/updatePris', { body:encrypt(JSON.stringify({
     data: _data,Userid:_data.userid,ipAdress:ipAdress,Afid:_data.Afid }))},{ 
     headers: {
      'Authorization':   `Bearer ${jwt}`
      }
    }).then( data => {
        console.log("updatePrisFromPrisList",data)
        dispatch(loadPrislista(_data.Artid, _data.userid, _data.Afid,Page-1,searchtext))
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true,msg: translate("Action.Save.list"), show: true, type: 'success', loading: false}})

    
    }).catch(err => {
      console.log(err)
    })
  }
}
//
export const loadArtikel = (artId, Userid,Afid) => {
  return async (dispatch) => {
   dispatch(resetZeroFreeInput())
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    axios.get('artikelReg/load', {params: encrypt(JSON.stringify({id: artId,Userid,Afid,ipAdress:ipAdress})),
    headers: {
     'Authorization':   `Bearer ${jwt}`
     }}).then( data  => {
      dispatch(RefreshUserInterface(Userid))
      console.log("loadArtikel",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_GET_ARTIKEL, payload: ndate.Artikel})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikel2: ", endata);
        history.goBack()
      }
    }).catch(err => {
      history.goBack()
      console.log(err)
    })
  }
}


export const getArtiklarCount = (afid, aktiv, Userid, FilterState,searchText="", FetchSubArtId = 0, AktivOffert = 0) => {
  return async (dispatch) => {
   
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    axios.get('artikelReg/count', { params:encrypt(JSON.stringify({
      Afid: afid, Aktiv: aktiv,Userid,ipAdress, FilterState, FetchSubArtId,searchText, AktivOffert
    })),
    headers: {
     'Authorization':   `Bearer ${jwt}`
     }}).then( data => {
      console.log("getArtiklarCount",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArtiklarCount1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_GET_ARTIKEL_COUNT, payload: ndate})
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const changeArtStatus = (id, aktiv, _data, flag, Userid) => {
  return async (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    axios.put('artikelReg/status', { body: encrypt(JSON.stringify({ 
      id: id, 
      Aktiv: aktiv,
      flag, 
      Userid,
      ipAdress
      }))},{  
      headers: {
        'Authorization':   `Bearer ${jwt}`
        }
    }).then( data  => {
      //dispatch(RefreshUserInterface(Userid))
      console.log("changeArtStatus",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))      
        dispatch(getArtiklarCount(_data.Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
        dispatch({type: ARTREG_ON_CHANGE_ACTIVE_STATUS, payload: ndate})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("changeArtStatus2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: ndate.error, show: true, type: 'error'}})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const changeArtisShared = (id, aktiv, _data, flag, Userid) => {
  return async (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    axios.put('artikelReg/isShared', { body: encrypt(JSON.stringify({
      id: id, 
      Aktiv: aktiv,
      flag, 
      Userid,
      ipAdress
      }))},{ 
      headers: {
        'Authorization':   `Bearer ${jwt}`
        }
    }).then( data => {
      //dispatch(RefreshUserInterface(Userid))
      console.log("changeArtisShared",data) 
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("changeArtisShared1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
        dispatch(getArtiklarCount(_data.Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
        dispatch({type: ARTREG_ON_CHANGE_ACTIVE_STATUS, payload: ndate})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const changeArtAktivOffert = (id, aktiv, _data, flag, Userid) => {
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.put('artikelReg/AktivOffert', { body:encrypt(JSON.stringify({
      id: id, 
      Aktiv: aktiv,
      flag, 
      Userid,
      ipAdress
    }))},{ 
    headers: {
      'Authorization':   `Bearer ${jwt}`
      }
    }).then( data => {
      console.log("changeArtAktivOffert",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("changeArtAktivOffert1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
      dispatch(getArtiklarCount(_data.Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
      dispatch({type: ARTREG_ON_CHANGE_ACTIVE_STATUS, payload: ndate})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const changeArtAktivKalk = (id, aktiv, _data, flag, Userid) => {
  return async (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    axios.put('artikelReg/AktivKalk', { body:encrypt(JSON.stringify({
      id: id, 
      Aktiv: aktiv,
      flag,
      Userid,
      ipAdress
    }))},{ 
    headers: {
      'Authorization':   `Bearer ${jwt}`
      }
    }).then( data => {
      console.log(_data,"_data")
      console.log("changeArtAktivKalk",data)
      if(data.data.success) { 
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("changeArtAktivKalk1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getArtiklar(_data.Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
        dispatch(getArtiklarCount(_data.Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
        dispatch({type: ARTREG_ON_CHANGE_ACTIVE_STATUS, payload: ndate})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeThumbnail = (id, FileName, Userid, Afid) => {
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.put('artikelReg/removeThumbnail', { body: encrypt(JSON.stringify({
      id: id, 
      FileName: FileName, 
      Userid,ipAdress,Afid
    }))},{ 
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("removeThumbnail",data)
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeThumbnail1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(loadArtikel(id,Userid,Afid))
        dispatch({type: ARTREG_ON_UPDATE_ARTIKEL, payload: ndate})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.Remove.thumbnail"), show: true, type: 'warning'}})
      }
      else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.Remove.thumbnail.Error"), show: true, type: 'error'}})
      }
     
    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeSheet = (id, FileNameSheet, Userid, Afid) => {
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.put('artikelReg/removeSheet', { body: encrypt(JSON.stringify({
      id: id, 
      Userid,ipAdress,Afid,FileNameSheet
    }))},{ 
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("removeSheet",data) 
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeSheet1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(loadArtikel(id,Userid,Afid))
        dispatch({type: ARTREG_ON_UPDATE_ARTIKEL, payload: ndate})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.Remove.item.sheet"), show: true, type: 'warning'}})
      }else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.Remove.item.sheet.Error"), show: true, type: 'error'}})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
//handleSyncFortnoxArt
export const handleSyncFortnoxArt = (id, Userid,Afid,FortnoxArticlenr,message) => {
  return async (dispatch) => {
    dispatch({type: ON_START_UPDATE_ARTIKEL_FORTNOX,payload:{message:message}});
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('artikelReg/Fortnox',
     { params:encrypt(JSON.stringify({Afid: Afid, userid: Userid,ArticleId:id,FortnoxArticlenr:FortnoxArticlenr,ipAdress:ipAdress})),
    headers: {
     'Authorization':   `Bearer ${jwt}`
     }}).then( data => {
      console.log("handleSyncFortnoxArt",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("handleSyncFortnoxArt1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_UPDATE_ARTIKEL_FORTNOX, payload: ndate})
        setTimeout(()=>{
          dispatch(loadArtikel(id,Userid,Afid))
          dispatch(loadPrislista(id,Userid,Afid))
        },500)
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("handleSyncFortnoxArt2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX, payload: ndate.error});
      }
     
    }).catch(err => {
      dispatch({type: ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX,payload:{message:{type:"error",message:translate("Action.item.toFontnox.Error")}}})
      console.log(err)
    })
  }
}
//handleSyncFortnoxArtUpdate
export const handleSyncFortnoxArtUpdate = (id, Userid,Afid,FortnoxArticlenr,message) => {
  return async (dispatch) => {
    dispatch({type: ON_START_UPDATE_ARTIKEL_FORTNOX,payload:{message:message}});
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('artikelReg/Fortnox/update',
     { params:encrypt(JSON.stringify({
      Afid: Afid, userid: Userid,ArticleId:id,FortnoxArticlenr:FortnoxArticlenr,ipAdress:ipAdress
    })),
    headers: {
     'Authorization':   `Bearer ${jwt}`
     }}).then( data => {
      console.log("handleSyncFortnoxArtUpdate",data)  
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("handleSyncFortnoxArtUpdate1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_UPDATE_ARTIKEL_FORTNOX, payload: ndate})
        setTimeout(()=>{
          dispatch(loadArtikel(id,Userid,Afid))
          dispatch(loadPrislista(id,Userid,Afid))
        },500)
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("handleSyncFortnoxArtUpdate2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX, payload: ndate.error});
      }
     
    }).catch(err => {
      dispatch({type: ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX,payload:{message:{type:"error",message:translate("Action.item.toFontnox.Error")}}})
      console.log(err)
    })
  }
}

//
export const updateArtInfo = (id, art, PrislistaUpdateArray, FreeInputsArr, Userid) => {
  // ARTREG_ON_START_UPDATE_ARTIKEL,
    // ARTREG_ON_ERROR_UPDATE_ARTIKEL,
    // ARTREG_ON_UPDATE_ARTIKEL,
  return async (dispatch) => {
    
    dispatch({type: ARTREG_ON_START_UPDATE_ARTIKEL})
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    const ipAdress='0.0.0.0'
		let extendedthumbNail = art.thumbNail
		if(art.thumbNail){
			const buffer = await art.thumbNail.arrayBuffer()
			extendedthumbNail = new File([buffer], 'thumbnail', {type: art.thumbNail.type})
		}
    formData.append('files[]', extendedthumbNail);
		let extendedsheet = art.sheet
		if(art.sheet){
			const buffer = await art.sheet.arrayBuffer()
			extendedsheet = new File([buffer], 'sheet', {type: art.sheet.type})
		}
    formData.append('files[]', extendedsheet);
    formData.append('id', id);
    formData.append('Afid', art.Afid);
    formData.append('Artnr', art.Artnr);
    formData.append('Artname', art.Artname);
    formData.append('Type', art.Type);
    formData.append('Artlev', art.Artlev);
    formData.append('Visningsnamn', art.Visningsnamn);
    formData.append('Enummer', art.Enummer);
    formData.append('Userid', Userid);
    formData.append('ipAdress', ipAdress);
    formData.append('Vat', art.Vat);
    formData.append('isShared', art.isShared);
    formData.append('isWithVAT', art.isWithVAT);
    formData.append('FortnoxArticlenr', art.FortnoxArticlenr);
    formData.append('ArtikelIntervall', art.ArtikelIntervall);
    formData.append('Enhet', art.Enhet);
    formData.append('Tags', JSON.stringify(art.Tags));
    formData.append('wcSkapaAvtal', art.wcSkapaAvtal);
    formData.append('effekt', art.effekt);
    formData.append('dimH', art.dimH);
    formData.append('dimB', art.dimB);
    formData.append('dimD', art.dimD);
    formData.append('dimT', art.dimT);
    formData.append('dimE', art.dimE);
    formData.append('garantiTid', art.garantiTid);
    formData.append('garantiTid2', art.garantiTid2);
    formData.append('effektEfterGarantiTid', art.effektEfterGarantiTid);
    formData.append('defaultInKalk', art.defaultInKalk);
    formData.append('Lager', art.Lager);
    formData.append('ThumbUrl', art.ThumbUrl);
    formData.append('SheetUrl', art.SheetUrl);
    formData.append('rot', art.rot);
    formData.append('ExkluderaIdashboard', art.ExkluderaIdashboard);
    formData.append('ExkluderaIeveryW', art.ExkluderaIeveryW);
    formData.append('desc', art.desc);
    formData.append('CreatePottId', art.CreatePottId);
    formData.append('CreatePottType', art.CreatePottType);
    formData.append('barcode', art.barcode);
    formData.append('GprovLopande', art.GprovLopande);
    formData.append('isMinuAr', art.isMinuAr);
    formData.append('isFastAr', art.isFastAr);
    formData.append('ReplaceSubArtValues', art.ReplaceSubArtValues);
    formData.append('IsPercentSubArtValue', art.IsPercentSubArtValue);
    formData.append('CanSetInprisOffert', art.CanSetInprisOffert);
    if(art.ReferenceArtColumnValue) formData.append('ReferenceArtColumnValue', art.ReferenceArtColumnValue);
    formData.append('PrislistaUpdateArray', JSON.stringify(PrislistaUpdateArray));
    formData.append('FreeInputsArr', JSON.stringify(FreeInputsArr));
    formData.append('ExcludeDiscountGprov', art.ExcludeDiscountGprov);
    axios.put('artikelReg/update', 
    formData,
        {
       /* body: {
          id: id, 
          Artnr: art.Artnr,
          Afid: art.Afid,
          Artname: art.Artname,
          Type: art.Type,
          Artlev: art.Artlev,
          Visningsnamn: art.Visningsnamn,
          Enummer: art.Enummer,
          FortnoxArticlenr: art.FortnoxArticlenr,
          ArtikelIntervall: art.ArtikelIntervall,
          Enhet: art.Enhet,
          Vat: art.Vat,
          isShared: art.isShared,
          isWithVAT: art.isWithVAT,
          Userid,ipAdress,
          Tags: JSON.stringify(art.Tags),
          wcSkapaAvtal: art.wcSkapaAvtal,
          effekt: art.effekt,
          dimH: art.dimH,
          dimB: art.dimB,
          dimD: art.dimD,
          dimT: art.dimT,
          dimE: art.dimE,
          garantiTid: art.garantiTid,
          garantiTid2: art.garantiTid2,
          defaultInKalk: art.defaultInKalk,
          Lager: art.Lager,
          ThumbUrl: art.ThumbUrl,
          rot: art.rot,
          ExkluderaIdashboard: art.ExkluderaIdashboard,
          effektEfterGarantiTid: art.effektEfterGarantiTid,
          desc: art.desc,
          CreatePottId: art.CreatePottId,
          CreatePottType: art.CreatePottType,
          barcode: art.barcode,
          GprovLopande: art.GprovLopande,
          isMinuAr: art.isMinuAr,
          isFastAr: art.isFastAr,
          ReplaceSubArtValues: art.ReplaceSubArtValues,
          PrislistaUpdateArray: PrislistaUpdateArray,
          FreeInputsArr: FreeInputsArr,
          IsPercentSubArtValue: art.IsPercentSubArtValue,
          ReferenceArtColumnValue: art.ReferenceArtColumnValue,
          ExcludeDiscountGprov: art.ExcludeDiscountGprov,
          ExkluderaIeveryW:art.ExkluderaIeveryW
        },*/
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      if(data.success){
        dispatch(loadArtikel(id,Userid,art.Afid))
        dispatch({type: ARTREG_ON_UPDATE_ARTIKEL, payload: data})
      } else {
        dispatch({type: ARTREG_ON_ERROR_UPDATE_ARTIKEL, payload: data.error})
      }
      //dispatch(RefreshUserInterface(Userid))
      console.log(data)
    }).catch(err => {
      dispatch({type: ARTREG_ON_ERROR_UPDATE_ARTIKEL, payload: translate("Action.save.item.Error",'Kunde inte spara #'+id+'!',{item:id})})
      console.log(err)
    })
  }
}

export const loadPrislista = (artId, Userid,Afid, Page = 0, Search = '', onlyKontoListor = 0) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARTREG_START_GET_PRICELISTS})
    axios.get('artikelReg/prislista/load', {params: encrypt(JSON.stringify({id: artId, Userid,ipAdress,Afid, Page, Search, onlyKontoListor})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("loadPrislista",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("loadPrislista1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_GET_PRICELISTS, payload: ndate})
        dispatch(RefreshUserInterface(Userid))
      }
      else{
        dispatch({type: ARTREG_ERROR_GET_PRICELISTS})
      }
    }).catch(err => {
      dispatch({type: ARTREG_ERROR_GET_PRICELISTS})
    })
  }
}
export const addPrislista = (prislista, Userid,konto,Afid, Orgnr, Page, Search) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.post('artikelReg/prislista/add', { body:encrypt(JSON.stringify({
      Artnr: prislista.Artnr,
      Artid: prislista.Artid,
      Utpris:  prislista.Utpris,
      Gprov:  prislista.Gprov,
      Inpris:  prislista.Inpris,
      Namn:  prislista.Namn,
      Mainprice: 0, 
      Userid,ipAdress,Afid:konto,Orgnr
    }))},{
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
    console.log("addPrislista",data)
    if(data.data.success) {
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("addPrislista1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch(loadPrislista(prislista.Artid,Userid,Afid, Page-1, Search))
      dispatch({type: ARTREG_ON_ADD_PRICELIST, payload: ndate})
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.item.price.added"), show: true, type: 'success'}})
    }
    else{
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.item.price.added.Error"), show: true, type: 'error'}})
    }
   
  }).catch(err => {
    dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.item.price.added.Error"), show: true, type: 'error'}})
    console.log(err)
  })
  }
}

export const deletePris = (id, Artid, Userid,ArtAfid,Afid, Page, Search) => {
  return async (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    
    const ipAdress='0.0.0.0'
    axios.delete('artikelReg/prislista/delete', { params:encrypt(JSON.stringify({ id,Userid,ipAdress,ArtAfid })),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("deletePris",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deletePris1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(loadPrislista(Artid,Userid,Afid, Page-1, Search))
        dispatch({type: ARTREG_ON_DELETE_PRICELIST, payload: ndate})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate('Action.item.price.delete','Pris #'+id+' borttagen!',{item:id}), show: true, type: 'warning'}})
      
      }
      else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate('Action.item.price.delete.Error','Kunde inte ta bort pris #'+id+'!',{item:id}), show: true, type: 'error'}})
      }
     
    }).catch(err => {
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate('Action.item.price.delete.Error','Kunde inte ta bort pris #'+id+'!',{item:id}), show: true, type: 'error'}})
      console.log(err)
    })
  }
}

export const changeMainPrice = (id, Artid, Utpris, Gprov, Userid,Afid, Page, Search) => {
  return async (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    
    const ipAdress='0.0.0.0'
    axios.put('artikelReg/prislista/setPrimaryList', { body: encrypt(JSON.stringify({
      id: id, 
      Artid: Artid,
      Utpris: Utpris,
      Gprov: Gprov, 
      Userid,ipAdress,Afid
    }))}, {
      headers: {
        'Authorization':   `Bearer ${jwt}`
      }
    }).then( data => {
      console.log("changeMainPrice",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("changeMainPrice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(loadPrislista(Artid,Userid,Afid, Page-1, Search))
        dispatch({type: ARTREG_ON_SET_PRIMARY_PRICELIST, payload: ndate})
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate('Action.item.price.main','Pris #'+id+' är nu primär!',{item:id}), show: true, type: 'info'}})
     }
      else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate('Action.item.price.main.Error','Kunde inte ta sätta pris #'+id+' till primär!',{item:id}), show: true, type: 'error'}})
      }
    }).catch(err => {
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate('Action.item.price.main.Error','Kunde inte ta sätta pris #'+id+' till primär!',{item:id}), show: true, type: 'error'}})
      console.log(err)
    })
  }
}

export const resetResponseData = () => {
  return async (dispatch) => {
    dispatch({type: ARTREG_ON_RESPOSE_RESET, payload: {}})
  }
}

//TAGS ------------------

export const createArtikelTag = (Afid, Userid, Keyword, Category, Color, TagOrder) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_NEW_ARTIKEL_TAGG})
    axios.post('artikelReg/tags', { body:encrypt(JSON.stringify({
      Afid, Userid, Keyword, Color,ipAdress,Category,TagOrder
    }))
  },{
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("createArtikelTag",data)
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createArtikelTag1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_NEW_ARTIKEL_TAGG, payload: ndate.results});
        dispatch(getArtikelTags(Afid, Userid))
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createArtikelTag2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_NEW_ARTIKEL_TAGG, payload: ndate.message});
      }
    
  }).catch(err => {
    console.log(err)
  })
  }
}

export const addTagToArtikel = (Afid, Userid, Tags, Art, _data) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('artikelReg/addtags', { body:encrypt(JSON.stringify({
      Afid, Userid, Tags, Art,ipAdress
    }))},{
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("addTagToArtikel",data)
      dispatch(getArtiklar(Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
      dispatch(getArtiklarCount(Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
      console.log(data)
  }).catch(err => {
    console.log(err)
  })
  }
}
export const activateArtikelArr = (Afid, Userid, Aktiv, Art, _data) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('artikelReg/activateArtikelArr', { body:encrypt(JSON.stringify({
      Afid, Userid, Aktiv, Art,ipAdress
    }))},{
    
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }})
    .then( data => {
        dispatch(getArtiklar(Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
        dispatch(getArtiklarCount(Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
      
  }).catch(err => {
    console.log(err)
  })
  }
}
export const setisSharedToArtikel = (Afid, Userid, isShared, Art, _data) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('artikelReg/setisShared', { body:encrypt(JSON.stringify({
      Afid, Userid, isShared, Art,ipAdress
    }))},{
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      dispatch(getArtiklar(Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
      dispatch(getArtiklarCount(Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
  }).catch(err => {
    console.log(err)
  })
  }
}
export const UpdateArtikelPrislistaMulti = (Afid, Userid, prislistor, Art, _data) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARTREG_ON_START_UPDATE_ARTIKEL_MULTI, payload: translate("Action.saveing.prices")})
    
    axios.post('artikelReg/UpdateArtikelPrislistaMulti', { body:encrypt(JSON.stringify({
      Afid, Userid, Art,ipAdress,prislistor
    }))},{
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("UpdateArtikelPrislistaMulti",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("UpdateArtikelPrislistaMulti1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_UPDATE_ARTIKEL_MULTI})
        dispatch(getArtiklar(Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
        dispatch(getArtiklarCount(Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
      }
      else{
        dispatch({type: ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI})
      }
    
  }).catch(err => {
    console.log(err)
  })
  }
}
export const setisSharedWithOfficeToArtikel = (Afid, Userid, isShared, Art, _data) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('artikelReg/setisSharedWithOffice', { body:encrypt(JSON.stringify({
      Afid, Userid, isShared, Art,ipAdress
    }))},{headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      dispatch(getArtiklar(Afid, _data.Page, _data.Filter, _data.PageSize, Userid,_data.FilterState, _data.SortObj,_data.searchtext))
      dispatch(getArtiklarCount(Afid, _data.Filter, Userid,_data.FilterState,_data.searchtext))
  }).catch(err => {
    console.log(err)
  })
  }
}

export const getArtikelTags = (Afid, Userid) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.get('artikelReg/tags', {params: encrypt(JSON.stringify({ Afid, Userid,ipAdress})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("getArtikelTags",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArtikelTags1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(RefreshUserInterface(Userid))
        dispatch({type: ARTREG_ON_GET_ARTIKEL_TAGS, payload: ndate})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getArtikelTagsDash = (Afid, Userid) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    axios.get('artikelReg/tags', {params: encrypt(JSON.stringify({ Afid, Userid,ipAdress})),
    }).then( data  => {
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArtikelTagsDash1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_GET_ARTIKEL_TAGS, payload: ndate})
        console.log(ndate)
      }
     
    }).catch(err => {
      console.log(err)
    })
  }
}

export const updateArtikelTag = (Afid, Userid, Keyword, Category, Order, Color, TagId) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_NEW_ARTIKEL_TAGG})
    axios.put('artikelReg/tags', { body: encrypt(JSON.stringify({
      Afid, Userid, Keyword, Color, TagId,ipAdress,Category,Order,
    }))}, {
      headers: {
        'Authorization':   `Bearer ${jwt}`
      }
    }).then( data  => {
      console.log("updateArtikelTag",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateArtikelTag1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPPDATE_ARTIKEL_TAGG, payload: ndate.results});
        dispatch(getArtikelTags(Afid, Userid))
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateArtikelTag2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_NEW_ARTIKEL_TAGG, payload: ndate.message});
      }
   
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteArtikelTag = (Afid, Userid, TagId,Keyword) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_NEW_ARTIKEL_TAGG})
    axios.delete('artikelReg/tags', { params:encrypt(JSON.stringify({
      Afid, Userid, TagId,Keyword,ipAdress
    })),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("deleteArtikelTag",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteArtikelTag1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DELETE_ARTIKEL_TAGG, payload: ndate.results});
        dispatch(getArtikelTags(Afid, Userid))
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteArtikelTag2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_NEW_ARTIKEL_TAGG, payload: ndate.message});
      }
     
    }).catch(err => {
      console.log(err)
    })
  }
}

export const addSubArtikel = (Afid, Userid, SubArt, ArtId, Type, Offset) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('artikelReg/subArt', { body:encrypt(JSON.stringify({
      Afid, Userid, SubArt, ArtId, Type,ipAdress
    }))},{headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("addSubArtikel",data) 
      if(data.data.success) {
        dispatch(getSubArtiklar(Afid, Userid, ArtId, Offset))
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.connected.item.added"), show: true, type: 'success'}})
      }
      else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.connected.item.added.Error"), show: true, type: 'error'}})
      }
    
  }).catch(err => {
    console.log(err)
    dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.connected.item.added.Error"), show: true, type: 'error'}})
  })
  }
}
export const updateSubArtikel = (Afid, Userid, SubArt, Offset, ArtId) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.put('artikelReg/subArt', { body:encrypt(JSON.stringify({
      Afid, Userid, SubArt, ipAdress
    })),
    },{
      headers: {
        'Authorization':   `Bearer ${jwt}`
      }
    }).then( data => {
      console.log("updateSubArtikel",data)
      if(data.data.success) {
        dispatch(getSubArtiklar(Afid, Userid, ArtId, Offset))
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.Connected.item.saved"), show: true, type: 'success'}})
      }
      else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.Connected.item.saved.Error"), show: true, type: 'error'}})
      }
    
  }).catch(err => {
    console.log(err)
    dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.Connected.item.saved.Error"), show: true, type: 'error'}})
  })
  }
}
export const getSubArtiklar = (Afid, Userid, ArtId, Offset) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.get('artikelReg/subArt', {params: encrypt(JSON.stringify({ Afid, Userid, ArtId,ipAdress, Offset })),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data  => {
      console.log("getSubArtiklar",data)  
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARTREG_ON_GET_ARTIKEL_SUB, payload: ndate})
        dispatch(RefreshUserInterface(Userid))
      }

    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeSubArtikel = (Afid, Userid, SubId, ArtId,Offset ) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.delete('artikelReg/subArt', { params:encrypt(JSON.stringify({ Afid, Userid, SubId,ipAdress})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("removeSubArtikel",data)
      if(data.data.success) {
        dispatch(getSubArtiklar(Afid, Userid, ArtId, Offset))
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: true, msg: translate("Action.Connected.item.deleted"), show: true, type: 'warning'}})
      }
      else{
        dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.Connected.item.deleted.Error"), show: true, type: 'error'}})
      }
  
    }).catch(err => {
      console.log(err)
      dispatch({type: ARTREG_ON_RESPOSE, payload: {success: false, msg: translate("Action.Connected.item.deleted.Error"), show: true, type: 'error'}})
    })
  }
}
export const connectWoocommerceProduct = (userid,Afid,Artid,WoocommerceProductID) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_CONNECT_WOOCOMMERCE_PRODUCT});
    axios.put('kontos/Woocommerce/product', {
      body: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Artid:Artid,
        WoocommerceProductID:WoocommerceProductID,ipAdress
      }))}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("connectWoocommerceProduct: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("connectWoocommerceProduct1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CONNECT_WOOCOMMERCE_PRODUCT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("connectWoocommerceProduct2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT, payload: ndate.error});
      }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const updateWholesaleProductData = (userid,Afid, WoocommerceProductID, WholeSaleData) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA});
    axios.put('kontos/Wholesale/product/data', encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        WoocommerceProductID:WoocommerceProductID,
        WholeSaleData,
        ipAdress
    })), {
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      } 
    }).then( data => {
      console.log("updateWholesaleProductData: ", data);
      if (data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateWholesaleProductData1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA, payload: ndate});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateWholesaleProductData2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const disconnectWoocommerceProduct = (userid,Afid,Artid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    
    dispatch({type: ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT});
    axios.delete('kontos/Woocommerce/product', {
      method: 'DELETE',
      params: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Artid:Artid,ipAdress
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("disconnectWoocommerceProduct: ", data);
      if (data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("disconnectWoocommerceProduct1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DISCONNECT_WOOCOMMERCE_PRODUCT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("disconnectWoocommerceProduct2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const createWoocommerceProduct = (userid,Afid,Artid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_CREATE_WOOCOMMERCE_PRODUCT});
    axios.post('kontos/Woocommerce/product', {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Artid:Artid,ipAdress
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("createWoocommerceProduct: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CREATE_WOOCOMMERCE_PRODUCT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikel2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onCheckIfStock
export const onCheckIfStock = (Afid,userid,ArticleId,FortnoxArticlenr,Lager,callBackFunc) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    
      axios.get('artikelReg/InStock',
      { params:encrypt(JSON.stringify({
        Afid:Afid,userid:userid,ArticleId:ArticleId,FortnoxArticlenr:FortnoxArticlenr
      })), 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       )
       .then( data => {
        console.log("onCheckIfStock: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onCheckIfStock: ", endata);
        let ndate = JSON.parse(endata)
          if(callBackFunc){
            callBackFunc({QuantityInStock:ndate.results.QuantityInStock,ReservedQuantity:ndate.results.ReservedQuantity})
          }
        }
        
         //dispatch(loadAktivaKalkylArtiklarJ(Afid,userid))
         //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
    
  }
}
export const onCheckIfStockReturnStock = (Afid,userid,ArticleId,FortnoxArticlenr,Lager) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    
      return await axios.get('artikelReg/InStock',
      { params:encrypt(JSON.stringify({Afid:Afid,userid:userid,ArticleId:ArticleId,FortnoxArticlenr:FortnoxArticlenr})), 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       )
       .then( data => {
        console.log("onCheckIfStock: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("addArtikel1: ", endata);
          let ndate = JSON.parse(endata)
          return ndate.results.QuantityInStock
        }
         dispatch(RefreshUserInterface(userid))         
      }).catch(function (error) {
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
    
  }
}
//onAddFreeInputArtikel
export const onAddFreeInputArtikel = (Afid,userid,Artid,NewType) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_ADD_NEW_FREEINPUT_ARTIKEL});
    axios.post('kontos/artikelReg/FreeInputs/Add', {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Artid:Artid,
        NewType:NewType
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("onAddFreeInputArtikel: ", data);
        if (data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("onAddFreeInputArtikel1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ADD_NEW_FREEINPUT_ARTIKEL, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("onAddFreeInputArtikel2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL, payload: ndate.error});
        }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//onCloseArtikleToaster
export const onCloseArtikleToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_START_ARTIKEL_CLOSE_TOASTR});
  }
}
//getArticleFreeInputs
export const getArticleFreeInputs = (Afid, Userid, ArtId) => {
  return async (dispatch) => {
    //ON_START_ADD_NEW_FREEINPUT_ARTIKEL
    dispatch({type: ON_START_GET_FREEINPUT_ARTIKEL});
    const jwt =  JSON.parse(localStorage.token);    
    axios.get('kontos/artikelReg/FreeInputs/get/all', 
    {params: encrypt(JSON.stringify({ Afid, Userid, ArtId})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("ON_GET_FREEINPUT_ARTIKEL",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArticleFreeInputs: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_FREEINPUT_ARTIKEL, payload: ndate.results});
      }      
    }).catch(err => {
      console.log(err)
    })
  }
}
//getThisArticleFreeInput
export const getThisArticleFreeInput = (Afid, Userid, ArtId,itemId) => {
  return async (dispatch) => {
    //ON_START_ADD_NEW_FREEINPUT_ARTIKEL
    dispatch({type: ON_START_GET_THIS_FREEINPUT_ARTIKEL});
    const jwt =  JSON.parse(localStorage.token);    
    axios.get('kontos/artikelReg/FreeInputs/get', 
    {params: encrypt(JSON.stringify({ Afid, Userid, ArtId,itemId})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("ON_GET_FREEINPUT_ARTIKEL",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_THIS_FREEINPUT_ARTIKEL, payload: ndate.results});
      }      
    }).catch(err => {
      console.log(err)
    })
  }
}
//resetZeroFreeInput
export const resetZeroFreeInput = () => {
  return (dispatch) => {
    dispatch({type:ON_START_GET_THIS_FREEINPUT_ARTIKEL});
  }
}
//onRemovethisFreeInputArtikel
export const onRemovethisFreeInputArtikel = (Afid,userid,ArtID,NewType) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'    
    dispatch({type: ON_START_DETELE_THIS_ARTICLE_FREEINPUT});
    axios.delete('kontos/artikelReg/FreeInputs/delete', {
      method: 'DELETE',
      data: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        ArtID:ArtID,NewType
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("onRemovethisFreeInputArtikel: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onRemovethisFreeInputArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DETELE_THIS_ARTICLE_FREEINPUT, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("onRemovethisFreeInputArtikel2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT, payload: ndate.error});
        }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//onupdateFreeInputArtikel
export const onupdateFreeInputArtikel = (Afid,userid,Artid,NewType) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_UPDATE_FREEINPUT_ARTIKEL});
    axios.post('kontos/artikelReg/FreeInputs/update', {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Artid:Artid,
        NewType:NewType
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("onAddFreeInputArtikel: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onAddFreeInputArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_FREEINPUT_ARTIKEL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("onAddFreeInputArtikel2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_FREEINPUT_ARTIKEL, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_FREEINPUT_ARTIKEL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//getArtikelFreeInpust
export const getArtikelFreeInpust = (Afid) => {
  return async (dispatch) => {
    //ON_START_ADD_NEW_FREEINPUT_ARTIKEL
    dispatch({type: ON_START_GET_THIS_FREEINPUTS_ARTIKEL});
    const jwt =  JSON.parse(localStorage.token);    
    axios.get('kontos/kalkyl/FreeInputs/get/all', 
    {params: encrypt(JSON.stringify({ Afid})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data => {
      console.log("ON_GET_FREEINPUT_ARTIKEL",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArtikelFreeInpust: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_THIS_FREEINPUTS_ARTIKEL, payload: ndate.results});
      }
      
    }).catch(err => {
      console.log(err)
    })
  }
}
//ExporteraArtiklarByAfid
export const ExporteraArtiklarByAfid = (Afid,userid) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    //ON_START_ADD_NEW_FREEINPUT_ARTIKEL
    dispatch({type: ON_START_GET_ARTEKLAR_EXCEL});
    const jwt =  JSON.parse(localStorage.token);    
    axios.get('kontos/Arteklar/download', 
    {params: encrypt(JSON.stringify({ Afid,userid })),
    responseType: 'arraybuffer' ,
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then((resp) => {
      const dirtyFileName = resp.headers['content-disposition'];
         const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
         var  fileName = dirtyFileName.match(regex)[3];
         var blob = new Blob([resp.data], 
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        dispatch({type: ON_GET_ARTEKLAR_EXCEL, payload: resp});
        fileSaver.saveAs(blob, fileName);
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_ARTEKLAR_EXCEL, payload: err.message});
      console.log(err)
    })
  }
}
//importArtiklarByAfid
export const importArtiklarByAfid = (Afid, userid,file) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = file; 
  var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_IMPORT_ARTIKLAR_FUNC});
    axios.post('kontos/Arteklar/upload',
    fromdata,
    {
      body:{
       Afid:Afid,
       userid:userid
      },
      headers: {
         'Content-Type': 'multipart/form-data',
         'Authorization':   `Bearer ${jwt}`
       }
    }
    ).then(({data}) => {
      if (data) {
        dispatch({type: ON_IMPORT_ARTIKLAR_FUNC, payload: data});
        dispatch(getArtiklarCount(Afid, [], userid))
        dispatch(getArtiklar(Afid, 0, [], 15, userid))
      }else{
        dispatch({type: ON_ERROR_IMPORT_ARTIKLAR_FUNC, payload: data.message});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_IMPORT_ARTIKLAR_FUNC, payload: error.message});
    })
  }
}
//onRemoveShareWithOffice
export const onRemoveShareWithOffice = (ArtId, userid,Afid,Office) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_Delete_SHARED_OFFICE})
    axios.delete('artikelReg/Office', { params:encrypt(JSON.stringify({ ArtId, userid,Afid,Office })),
    headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then( data  => {
      console.log("onRemoveShareWithOffice",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onRemoveShareWithOffice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_Delete_SHARED_OFFIC, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("onRemoveShareWithOffice2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_Delete_SHARED_OFFIC, payload: ndate.message});
      }
    
    }).catch(err => {
      console.log(err)
    })
  }
}
//onAddShareWithOffice
export const onAddShareWithOffice = (ArtId,userid,Afid,OfficeId) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_Delete_SHARED_OFFICE})
    axios.put('artikelReg/Office', { body: encrypt(JSON.stringify({
      ArtId,userid,Afid,OfficeId
    }))}, {
      headers: {
        'Authorization':   `Bearer ${jwt}`
      }
    }).then( data  => {
      console.log("onAddShareWithOffice",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onAddShareWithOffice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_Delete_SHARED_OFFIC, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("onAddShareWithOffice2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_Delete_SHARED_OFFIC, payload: ndate.message});
      }
   
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
//onSetarticklarcurrTabIndex
export const onSetarticklarcurrTabIndex = (TabIndex) => {
  return (dispatch) => {
    dispatch({type:ON_SET_ARTIKLAR_TAB_INDEX, payload: {TabIndex}});
  }
}
//setArtiklarPage
export const setArtiklarPage = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_ARTIKLAR_PAGE_BASIC, payload: {Page:Page+1}});
   }
}
